<template>
  <div class="sub-wrap">
    <div class="page-content-first" v-if="taxQuestionType == 3">
      <div class="layout-content-main">
        <div class="top-box">
          <div>
            <span style="font-size: 16px; font-weight: 700">税款所属期</span>
            <span
                style="margin-inline-start: 5px; font-size: 12px; font-weight: 600; color: #f90">{{
                staticConfig.taxDurationTime
              }}</span>
            <span
                style="margin-inline-start: 5px; font-size: 12px; color: #333">({{
                staticConfig.taxStartTime
              }}至{{ staticConfig.taxEndTime }})</span>
          </div>
          <div>
            <el-button type="primary" plain @click="emit('startExam')">我要填表</el-button>
          </div>
        </div>

        <el-card class="box-card">
          <template #header>
            <span class="heade-tips">本期应补(退)税额</span>
          </template>
          <div class="card-box2">
            <el-row>
              <el-col :span="6" style="background-color: #f9fafd; margin: 8px">
                <div class="item-box" style="height: 160px">
                  <div class="item-logo1">
                    <img src="https://static.rhkj.com/renhe_fe/other/reportTax/total.png" alt="#"/>
                  </div>
                  <div class="item-text">
                    <p class="p-1">合计</p>
                    <p class="p-2">{{ pageShowInfo3.hj }}</p>
                  </div>
                </div>
              </el-col>
              <el-col :span="17" style="background-color: #f9fafd; margin: 8px; height: 160px">
                <el-row>
                  <el-col :span="12">
                    <div class="item-box" style="height: 80px">
                      <div class="item-logo1">
                        <img src="https://static.rhkj.com/renhe_fe/other/reportTax/card.png" alt="#"/>
                      </div>
                      <div class="item-text">
                        <p class="p-1">增值税</p>
                        <p class="p-2">{{ pageShowInfo3.zzs }}</p>
                      </div>
                    </div>
                  </el-col>
                  <el-col :span="12">
                    <div class="item-box" style="height: 80px">
                      <div class="item-logo1">
                        <img src="https://static.rhkj.com/renhe_fe/other/reportTax/build.png" alt="#"/>
                      </div>
                      <div class="item-text">
                        <p class="p-1">城市维护费</p>
                        <p class="p-2">{{ pageShowInfo3.cswhf }}</p>
                      </div>
                    </div>
                  </el-col>
                </el-row>

                <el-row>
                  <el-col :span="12">
                    <div class="item-box" style="height: 80px">
                      <div class="item-logo1">
                        <img src="https://static.rhkj.com/renhe_fe/other/reportTax/educate.png" alt="#"/>
                      </div>
                      <div class="item-text">
                        <p class="p-1">教育费附加</p>
                        <p class="p-2">{{ pageShowInfo3.jyffj }}</p>
                      </div>
                    </div>
                  </el-col>
                  <el-col :span="12">
                    <div class="item-box" style="height: 80px">
                      <div class="item-logo1">
                        <img src="https://static.rhkj.com/renhe_fe/other/reportTax/film.png" alt="#"/>
                      </div>
                      <div class="item-text">
                        <p class="p-1">地方教育附加</p>
                        <p class="p-2">{{ pageShowInfo3.dfjyfj }}</p>
                      </div>
                    </div>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
          </div>
        </el-card>

        <el-card class="box-card">
          <template #header>
            <span class="heade-tips">销售和抵扣信息</span>
          </template>
          <div class="card-box3">
            <div class="card-content-box">
              <div class="content-title">销售收入</div>
              <el-row>
                <el-col :span="11" :offset="1">
                  <div class="content-text">
                    <p>销售额</p>
                    <el-input :readonly="true"
                              :model-value="pageShowInfo3.xse"
                              suffix-icon="edit"></el-input>
                  </div>
                </el-col>
                <el-col :span="11" :offset="1">
                  <div class="content-text">
                    <p>税额</p>
                    <span style="line-height: 35px">{{ pageShowInfo3.se }}</span>
                  </div>
                </el-col>
              </el-row>
            </div>

            <div class="card-content-box">
              <div class="content-title">销售收入</div>
              <el-row class="content-text1">
                <el-col :span="23" :offset="1" class="">
                  <p>认证相符的增值税专用发票税额</p>
                  <p style="font-size: 16px">{{ pageShowInfo3.rzxf }}</p>
                  <p>海关进口增值税专用缴款书税额</p>
                  <p style="font-size: 16px">0.00</p>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-card>

        <el-card class="box-card">
          <template #header>
            <span class="heade-tips">税费计算信息</span>
          </template>
          <div class="card-box4">
            <div class="card-box4-title">
              <span>增值税</span>
              <span>应补（退）税额: &nbsp; {{ pageShowInfo3.ybte }} </span><i class="el-icon-warning-outline"></i>
            </div>
            <div class="card-box4-content">
              <el-row>
                <el-col :span="8"><span>&#9312; 销项税额: {{ pageShowInfo3.xxse }}</span></el-col>
                <el-col :span="8"><span>&#9313; 进项税额: {{ pageShowInfo3.jxse }}</span></el-col>
                <el-col :span="8"><span>&#9314; 上期留抵税额: {{ '0.00' }}</span></el-col>
              </el-row>
              <el-row>
                <el-col :span="8"><span>&#9315; 简易计税办法计算的应纳税额: {{ '0.00' }}</span></el-col>
                <el-col :span="8"><span>&#9316; 应纳税额减征额: {{ '0.00' }}</span></el-col>
                <el-col :span="8"><span>&#9317; 分次预缴税额: {{ '0.00' }}</span></el-col>
              </el-row>
              <el-row>
                <el-col :span="8"><span>&#9318; 本期进项转出: {{ '0.00' }}</span></el-col>
                <el-col :span="8"><span>&#9319; 加计抵减本期实示抵减额: {{ '0.00' }}</span></el-col>
              </el-row>
            </div>
          </div>
        </el-card>
      </div>
      <div class="footer-box">
        <div class="footer-box-content">
          <el-button type="default">预览报表</el-button>
          <el-button type="primary" @click="submitHandler3">提交</el-button>
        </div>
      </div>
    </div>

    <div class="page-content-second" v-else-if="taxQuestionType == 2">
      <div class="layout-content-main">
        <el-card class="box-card" style="margin-top: 20px">
          <template #header>
            <div class="header-box">
              <div>
                <span style="font-weight: 700">税款所属期</span>

                <span
                    style="margin-left: 5px; font-size: 14px; font-weight: 700; color: #f90">{{
                    staticConfig.taxDurationTime
                  }}</span>
                <span
                    style="margin-left: 5px; font-size: 12px">({{
                    staticConfig.taxStartTime
                  }}至{{ staticConfig.taxEndTime }})</span>
              </div>
              <div>
                <el-button type="primary" plain @click="emit('startExam')">我要填表</el-button>
              </div>
            </div>
          </template>
          <div class="card-box3">
            <h3 class="title-text">预缴税款信息</h3>
            <div style="padding: 10px 0">
              <el-row>
                <el-col :span="4">
                  <div style="padding: 5px 0">
                    <p style="line-height: 30px">
                      <i style="color: red">*</i>
                      季末从业人数
                    </p>
                    <el-input :readonly="true" :model-value="pageShowInfo2.jmcy"/>
                  </div>
                </el-col>
                <el-col :span="6" :offset="1">
                  <div style="padding: 5px 0">
                    <p style="line-height: 30px">
                      <i style="color: red">*</i>
                      季末资产总额（万元）
                    </p>
                    <el-input :readonly="true" :model-value="pageShowInfo2.jmzc"/>
                  </div>
                </el-col>
                <el-col :span="6" :offset="1">
                  <div style="padding: 5px 0">
                    <p style="line-height: 30px">营业收入本年累计金额</p>
                    <el-input :readonly="true" :model-value="pageShowInfo2.yysr"/>
                  </div>
                </el-col>
                <el-col :span="5" :offset="1">
                  <div style="padding: 5px 0">
                    <p style="line-height: 30px">营业成本本年累计金额</p>
                    <el-input :readonly="true" :model-value="pageShowInfo2.yycb"/>
                  </div>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="4">
                  <div style="padding: 5px 0">
                    <p style="line-height: 30px">利润总额本年累计金额</p>
                    <el-input :readonly="true" :model-value="pageShowInfo2.lrze"/>
                  </div>
                </el-col>
                <el-col :span="6" :offset="1">
                  <div style="padding: 5px 0">
                    <p style="line-height: 30px">扶贫捐赠支出全额扣除本年累计金额</p>
                    <el-input :readonly="true" :model-value="pageShowInfo2.fpjz"/>
                  </div>
                </el-col>
                <el-col :span="6" :offset="1">
                  <div style="padding: 5px 0">
                    <p style="line-height: 30px">民族自治区企业所得税地方分享部分</p>
                    <el-radio-group :disabled="true">
                      <el-radio label="免征" value="1"/>
                      <el-radio label="减征" value="2"/>
                    </el-radio-group>
                  </div>
                </el-col>
                <el-col :span="5" :offset="1">
                  <div style="padding: 5px 0">
                    <p style="line-height: 30px">减征幅度（%）</p>
                    <el-input :disabled="true"/>
                  </div>
                </el-col>
              </el-row>
            </div>

            <div style="background-color: #f9fafd">
              <h3 style="line-height: 40px; font-weight: 700">税款计算</h3>
              <div style="border-bottom: 4px solid #fff">
                <div style="padding: 10px; display: inline-flex; align-items: center; justify-content: center">
                  <div style="width: 35px; height: 35px; margin-right: 15px">
                    <img src="https://static.rhkj.com/renhe_fe/other/reportTax/calc.png" alt="#"
                         style="width: 100%; object-fit: cover"/>
                  </div>
                  <p style="font-size: 14px">实际应补（退）所得税额 &#9312;</p>
                </div>
              </div>

              <div class="shuie-item-box">
                <div class="content-text-box">
                  <p style="padding: 5px 0">&#9312;实际利润额</p>
                  <span style="line-height: 35px; padding-left: 20px">{{ pageShowInfo2.sjlr }}</span>
                </div>
                <div class="content-text-box">
                  <p style="padding: 5px 0">&#9313; 税率</p>
                  <span style="line-height: 35px; padding-left: 20px">{{ pageShowInfo2.sl }}</span>
                </div>
                <div class="content-text-box">
                  <p style="padding: 5px 0">&#9314; 应纳所得税额</p>
                  <span style="line-height: 35px; padding-left: 20px">{{ pageShowInfo2.ynTax }}</span>
                </div>
                <div class="content-text-box">
                  <p style="padding: 5px 0">&#9315; 小型微利企业减免税额</p>
                  <span style="line-height: 35px; padding-left: 20px">{{ pageShowInfo2.xwjm }}</span>
                </div>
                <div class="content-text-box">
                  <p style="padding: 5px 0">&#9316; 本年实际已缴纳所得税额</p>
                  <span style="line-height: 35px; padding-left: 20px">{{ pageShowInfo2.bnsj }}</span>
                </div>
              </div>
            </div>

            <div class="btns-box">
              <div class="left-btn-box">
                <span>实际应补（退）所得税额 </span>
                <el-icon style="vertical-align: middle">
                  <Warning/>
                </el-icon>
                <span
                    style="font-size: 20px; font-weight: 700; color: #ed5353">{{ pageShowInfo2.sjyb }}</span>元，(<span> {{
                  pageShowInfo2.sjybChinese
                }}</span>)
              </div>
              <div class="buttton-box">
                <el-button type="default">预览报表</el-button>
                <el-button type="primary" @click="submitHandler2">提交申报</el-button>
              </div>
            </div>
          </div>
        </el-card>
      </div>
    </div>

    <div class="page-content-first" v-if="taxQuestionType == 1">
      <div class="layout-content-main">
        <div class="top-box">
          <div>
            <span style="font-size: 16px; font-weight: 700">税款所属期</span>
            <span
                style="margin-inline-start: 5px; font-size: 12px; font-weight: 600; color: #f90">{{
                staticConfig.taxDurationTime
              }}</span>
            <span
                style="margin-inline-start: 5px; font-size: 12px; color: #333">({{
                staticConfig.taxStartTime
              }}至{{ staticConfig.taxEndTime }})</span>
          </div>
          <div>
            <el-button type="primary" plain @click="emit('startExam')">我要填表</el-button>
          </div>
        </div>

        <el-card class="box-card">
          <template #header>
            <span class="heade-tips">本期应补(退)税额</span>
          </template>
          <div class="card-box2">
            <el-row>
              <el-col :span="6" style="background-color: #f9fafd; margin: 8px">
                <div class="item-box" style="height: 160px">
                  <div class="item-logo1">
                    <img src="https://static.rhkj.com/renhe_fe/other/reportTax/total.png" alt="#"/>
                  </div>
                  <div class="item-text">
                    <p class="p-1">合计</p>
                    <p class="p-2">{{ pageShowInfo1.hj }}</p>
                  </div>
                </div>
              </el-col>

              <el-col :span="17" style="background-color: #f9fafd; margin: 8px; height: 160px">
                <el-row>
                  <el-col :span="8">
                    <div class="item-box" style="height: 80px">
                      <div class="item-logo1">
                        <img src="https://static.rhkj.com/renhe_fe/other/reportTax/card.png" alt="#"/>
                      </div>
                      <div class="item-text">
                        <p class="p-1">增值税</p>
                        <p class="p-2">{{ pageShowInfo1.zzs }}</p>
                      </div>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="item-box" style="height: 80px">
                      <div class="item-logo1">
                        <img src="https://static.rhkj.com/renhe_fe/other/reportTax/build.png" alt="#"/>
                      </div>
                      <div class="item-text">
                        <p class="p-1">城市维护建设费</p>
                        <p class="p-2">{{ pageShowInfo1.cswhf }}</p>
                      </div>
                    </div>
                  </el-col>

                  <el-col :span="8">
                    <div class="item-box" style="height: 80px">
                      <div class="item-logo1">
                        <img src="https://static.rhkj.com/renhe_fe/other/reportTax/film.png" alt="#"/>
                      </div>
                      <div class="item-text">
                        <p class="p-1">教育费附加</p>
                        <p class="p-2">{{ pageShowInfo1.jyffj }}</p>
                      </div>
                    </div>
                  </el-col>
                </el-row>

                <el-row>
                  <el-col :span="8">
                    <div class="item-box" style="height: 80px">
                      <div class="item-logo1">
                        <img src="https://static.rhkj.com/renhe_fe/other/reportTax/educate.png" alt="#"/>
                      </div>
                      <div class="item-text">
                        <p class="p-1">地方教育附加</p>
                        <p class="p-2">{{ pageShowInfo1.dfjyfj }}</p>
                      </div>
                    </div>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
          </div>
        </el-card>

        <el-card class="box-card">
          <template #header>
            <span class="heade-tips">本期销售情况</span>
          </template>
          <div class="card-box3">
            <div class="card-content-box" style="width: 100%;padding-bottom: 10px;">
              <div class="content-title">增值税销售收入</div>
              <el-row>
                <el-col :span="5" :offset="1">
                  <div class="content-text">
                    <p>货物及劳务销售额</p>
                    <el-input :readonly="true"
                              :model-value="pageShowInfo1.hwjlw"
                              suffix-icon="edit"></el-input>
                  </div>
                </el-col>

                <el-col :span="5" :offset="1">
                  <div class="content-text">
                    <p>税额</p>
                    <span style="line-height: 35px">{{ pageShowInfo1.hwjlwTax }}</span>
                  </div>
                </el-col>

                <el-col :span="5" :offset="1">
                  <div class="content-text">
                    <p>服务、不动产和无形资产销售额</p>
                    <el-input :readonly="true"
                              :model-value="pageShowInfo1.fwbd"
                              suffix-icon="edit"></el-input>
                  </div>
                </el-col>

                <el-col :span="5" :offset="1">
                  <div class="content-text">
                    <p>税额</p>
                    <span style="line-height: 35px">{{ pageShowInfo1.fwbdTax }}</span>
                  </div>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="5" :offset="1">
                  <div class="content-text">
                    <p>核定销售额</p>
                    <span style="line-height: 35px">{{ pageShowInfo1.hwjlwSale }}</span>
                  </div>
                </el-col>

                <el-col :span="5" :offset="1">
                  <div class="content-text">
                    <p>核定应纳税额</p>
                    <span style="line-height: 35px">{{ pageShowInfo1.hwjlwShould }}</span>
                  </div>
                </el-col>

                <el-col :span="5" :offset="1">
                  <div class="content-text">
                    <p>核定销售额</p>
                    <span style="line-height: 35px">{{ pageShowInfo1.fwbdSale }}</span>
                  </div>
                </el-col>

                <el-col :span="5" :offset="1">
                  <div class="content-text">
                    <p>核定应纳税额</p>
                    <span style="line-height: 35px">{{ pageShowInfo1.fwbdShould }}</span>
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-card>

        <el-card class="box-card">
          <template #header>
            <span class="heade-tips">税费计算信息</span>
          </template>
        </el-card>
      </div>
      <div class="footer-box">
        <div class="footer-box-content">
          <el-button type="default">预览报表</el-button>
          <el-button type="primary" @click="submitHandler3">提交</el-button>
        </div>
      </div>
    </div>

    <div class="page-content-four" v-if="taxQuestionType == 4">
      <div class="four-content">
        <div class="title-m">财务报表报送种类</div>

        <el-row>
          <el-col :span="8">
            <div class="sub-form-label">报送期间</div>
            <el-radio-group size="large" v-model="formData.duration">
              <el-radio value="1">季报</el-radio>
              <el-radio value="2">年报</el-radio>
            </el-radio-group>
          </el-col>

          <el-col :span="10">
            <div class="sub-form-label">报送所属期间</div>
            <el-date-picker
                style="width: 200px"
                type="year"
                disabled
                size="large"
                placeholder="请选择年份"
                :model-value="staticConfig.belongYear"
            />
            <span style="margin-left: 10px;">({{ staticConfig.taxStartTime }}至{{ staticConfig.taxEndTime }})</span>
          </el-col>
        </el-row>

        <el-row style="margin-top: 30px;">
          <el-col :span="8">
            <div class="sub-form-label">报送小类</div>
            <el-input
                v-model="formData.subType"
                disabled
                size="large"
            />
          </el-col>
        </el-row>

        <div class="title-m" style="margin-top: 20px;">报送模式选择</div>

        <div class="mode-choose">
          <div v-for="(item,idx) in modeChooseList"
               class="mode-item"
               :class="{'active': modeChooseActIdx == idx}"
               @click="modeChooseActIdx = idx"
               :key="idx">
            <h3>{{ item.nameMain }}</h3>
            <h4>{{ item.desc }}</h4>

            <el-icon class="act-icon" color="#4285f4"><Select/></el-icon>
          </div>
        </div>

        <div class="opera-t">
          <el-button
              size="large"
              type="primary"
              @click="emit('startExam')"
          >下一步
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="jsx">
import Big from "big.js";
import {toCapitalChinese} from "@/utils/number";
import {ElMessage, ElMessageBox} from "element-plus";
import {$emit, $on} from "vue-happy-bus";
import {reportTaxDateConfig} from "@/views/examCenter/reportTax/reportTaxStaticConfig.js";

const emit = defineEmits(['startExam', 'finish']);

const props = defineProps({
  currentQa: { // 当前题目信息对象
    required: true,
    type: Object,
  },
})

const taxQuestionType = computed(() => {
  switch (props.currentQa.sonQueType) {
    case '21':
      return 1
    case '22':
    case '26':
    case '2201':
    case '2601':
      return 2
    case '23':
      return 3
    case '27':
    case '28':
    case '29': // 汇算清缴-财务报表报送
      return 4
    default:
      throw new Error('不支持的类型')
  }
})

const {staticConfig} = reportTaxDateConfig(props.currentQa)

// 题目json信息转js对象
const qaData = computed(() => {
  const taxDataAll = props.currentQa?.solution && JSON.parse(props.currentQa.solution) || null
  return taxDataAll == null ? JSON.parse(props.currentQa.answer) : taxDataAll
})

// 一般纳税人，页面显示的金额，题目3
const pageShowInfo3 = computed(() => {
  console.log('题目信息', qaData.value)

  return {
    zzs: parseFloatNum(qaData.value.tax31.data.v34x1.value),
    cswhf: parseFloatNum(qaData.value.tax31.data.v39x1.value),
    jyffj: parseFloatNum(qaData.value.tax31.data.v40x1.value),
    dfjyfj: parseFloatNum(qaData.value.tax31.data.v41x1.value),
    hj: parseFloatNum(
        new Big(qaData.value.tax31.data.v34x1.value)
            .plus(qaData.value.tax31.data.v39x1.value)
            .plus(qaData.value.tax31.data.v40x1.value)
            .plus(qaData.value.tax31.data.v41x1.value)
    ),

    xse: parseFloatNum(qaData.value.tax31.data.v1x1.value),
    se: parseFloatNum(qaData.value.tax31.data.v11x1.value),
    rzxf: parseFloatNum(qaData.value.tax31.data.v12x1.value),
    ybte: parseFloatNum(qaData.value.tax31.data.v34x1.value),

    xxse: parseFloatNum(qaData.value.tax31.data.v11x1.value),
    jxse: parseFloatNum(qaData.value.tax31.data.v12x1.value),
  }
})

//小规模，页面显示的金额，题目1
const pageShowInfo1 = computed(() => {
  return {
    zzs: parseFloatNum(qaData.value.tax11.data.v22x1.value),
    cswhf: parseFloatNum(qaData.value.tax11.data.v23x1.value),
    jyffj: parseFloatNum(qaData.value.tax11.data.v24x1.value),
    dfjyfj: parseFloatNum(qaData.value.tax11.data.v25x1.value),
    hj: parseFloatNum(
        new Big(qaData.value.tax11.data.v22x1.value)
            .plus(qaData.value.tax11.data.v23x1.value)
            .plus(qaData.value.tax11.data.v24x1.value)
            .plus(qaData.value.tax11.data.v25x1.value)
    ),

    hwjlw: parseFloatNum(qaData.value.tax11.data.v1x3.value),
    hwjlwTax: parseFloatNum(qaData.value.tax11.data.v15x3.value),
    fwbd: parseFloatNum(qaData.value.tax11.data.v1x4.value),
    fwbdTax: parseFloatNum(qaData.value.tax11.data.v15x4.value),
    hwjlwSale: '0.00', // 核定销售额 根据文档找不到
    hwjlwShould: '0.00', // 核定应纳税额 根据文档找不到
    fwbdSale: '0.00', // 核定销售额 根据文档找不到
    fwbdShould: '0.00', // 核定应纳税额 根据文档找不到
  }
})

//企业所得税，页面显示的金额，题目2
const pageShowInfo2 = computed(() => {
    if (['22', '26'].includes(props.currentQa.sonQueType)) {
        return {
            jmcy: props.currentQa.sonQueType == '26' ?  parseFloatNum(qaData.value.tax21.data.v1x8.value) : parseFloatNum(qaData.value.tax21.data.v1x4.value),
            jmzc: parseFloatNum(qaData.value.tax21.data.v2x4.value),
            yysr: parseFloatNum(qaData.value.tax21.data.v7x1.value),
            yycb: parseFloatNum(qaData.value.tax21.data.v8x1.value),
            lrze: parseFloatNum(qaData.value.tax21.data.v9x1.value),
            fpjz: '0.00',

            sjlr: parseFloatNum(qaData.value.tax21.data.v20x1.value),
            sl: `${parseFloatNum(qaData.value.tax21.data.v21x1.value * 100)}%`,
            ynTax: parseFloatNum(qaData.value.tax21.data.v22x1.value),
            xwjm: parseFloatNum(qaData.value.tax21.data.v24x2.value),
            bnsj: parseFloatNum(qaData.value.tax21.data.v26x1.value),
            sjyb: parseFloatNum(qaData.value.tax21.data.v28x1.value),
            sjybChinese: toCapitalChinese(qaData.value.tax21.data.v28x1.value),
        }
    } else if (['2201', '2601'].includes(props.currentQa.sonQueType)) {
        // v2025新版企业税报表取数
        return {
            jmcy: props.currentQa.sonQueType == '2601' ?  parseFloatNum(qaData.value.tax21.data.v1x8.value) : parseFloatNum(qaData.value.tax21.data.v1x4.value),
            jmzc: parseFloatNum(qaData.value.tax21.data.v2x4.value),
            yysr: parseFloatNum(qaData.value.tax21.data.v12x2.value), // 营业收入本年累计金额
            yycb: parseFloatNum(qaData.value.tax21.data.v16x2.value), // 营业成本本年累计金额
            lrze: parseFloatNum(qaData.value.tax21.data.v34x2.value), // 利润总额本年累计金额
            fpjz: '0.00',

            sjlr: parseFloatNum(qaData.value.tax21.data.v42x2.value), // 实际利润额
            sl: `${parseFloatNum(qaData.value.tax21.data.v43x2.value * 100)}%`,
            ynTax: parseFloatNum(qaData.value.tax21.data.v44x2.value), // 应纳所得税额
            xwjm: parseFloatNum(qaData.value.tax21.data.v45x2.value), // 小型微利企业减免税额
            bnsj: parseFloatNum(qaData.value.tax21.data.v48x2.value), // 本年实际已缴纳所得税额
            sjyb: parseFloatNum(qaData.value.tax21.data.v50x2.value), // 实际应补（退）所得税额
            sjybChinese: toCapitalChinese(qaData.value.tax21.data.v50x2.value),
        }
    } else {
        return {}
    }
})

// 小数点
function parseFloatNum(s, num = 2) {
  try {
    return new Big(s).toFixed(num);
  } catch (e) {
    console.log(e);
  }
}

function riskShow() {
  ElMessage.warning('风险提示服务功能暂未开发')
}


/*
 * ！！！提交写数据区
 */

// 爷爷组件，保存成功回调
$on('saveQaSuccess', res => {
  const data = JSON.parse(res?.serverData?.solution || "{}")
  if (data.status == 1) { // 提交了，则进入申报成功页面
    emit('finish')
  }
})

const getGrandchildValue = inject('getGrandchildValue');
getGrandchildValue.value.getData = (byUser) => {
  if (!Boolean(byUser)) { // 非用户主动保存数据，不触发修改solution。即报税题需用户手动点击保存按钮
    return {}
  }
  const taxDataAll = {
    ...qaData.value,
    status: 1, // 状态为提交
  };
  return {
    solution: JSON.stringify(taxDataAll),
  }
}

// 第2题提交
function submitHandler2() {
  const vnode = <div style="line-height: 22px;">
    <div>为提升您的申报数据质量，税务机关已为您提供税收政策遵从风险提示服务。</div>
    <div>选择 ”风险提示服务“ : 享受税收政策风险扫描服务，提高申报数据质量。</div>
    <div>选择 ”提交申报“ : 跳过风险提示服务，继续申报</div>
  </div>

  ElMessageBox.confirm(vnode, '提示', {
    confirmButtonText: '提交申报',
    cancelButtonText: '风险提示服务',
    distinguishCancelAndClose: true,
    type: '',
  })
      .then(() => {
        ElMessageBox.confirm('声明: 此表是根据国家税收法律法规及相关规定填写，本人（单位）确认填报内容真实可靠，完整，并自愿对填报内容承担法律责任。', '信息确认', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          distinguishCancelAndClose: true,
          type: 'warning',
        })
            .then(() => {
              $emit('exeSaveQa', {status: 1})
            })
            .catch()
      })
      .catch(action => {
        if (action == 'cancel') {
          riskShow()
        }
      });
}

//第3题、第1题提交
function submitHandler3() {
  ElMessageBox.confirm('声明: 此表是根据国家税收法律法规及相关规定填写，本人（单位）确认填报内容真实可靠，完整，并自愿对填报内容承担法律责任。', '信息确认', {
    confirmButtonText: '确认',
    cancelButtonText: '取消',
    type: 'warning',
  })
      .then(() => {
        $emit('exeSaveQa', {status: 1})
      })
      .catch(() => {
      });
}

const formData = ref({
  subType: '财务报表报送与信息采集（小企业会计准则）',
  duration: '1',
})

onMounted(() => {
  if (props.currentQa.sonQueType == '29') {
    formData.value.duration = '2'
  }
})

const modeChooseActIdx = ref(0)
const modeChooseList = ref([
  {
    nameMain: '财报导入',
    desc: '导入标准模板表单',
  },
  {
    nameMain: '财报转换',
    desc: '转换财务软件导出的报表',
  },
  {
    nameMain: '在线填写',
    desc: '在线填写申报表',
  },
])
</script>

<style scoped lang="scss">
.sub-wrap {
  box-sizing: border-box;
  width: 100%;

  .page-content-first {
    width: inherit;
    height: calc(100vh - 100px);
    overflow-y: auto;
    background-color: #f7f8fa;

    .layout-content-main {
      width: 1184px;
      padding-bottom: 48px;
      margin: 0 auto;
      border-radius: 2px;
      display: flex;
      flex-direction: column;
      row-gap: 20px;

      .top-box {
        padding: 10px 20px;
        margin-top: 10px;
        background-color: #fff;
        display: flex;
        justify-content: space-between;
        align-items: center;
      }

      .heade-tips {
        font-size: 14px;
        font-weight: 700;
      }

      :deep(.box-card) {
        box-shadow: none;

        .el-card__body {
          .card-box2 {
            .item-box {
              display: flex;
              align-items: center;
              width: 100%;
              padding-left: 30px;

              .item-logo1 {
                width: 40px;
                height: 40px;

                > img {
                  width: 100%;
                  height: 100%;
                  object-fit: cover;
                }
              }

              .item-text {
                line-height: 30px;
                margin-left: 10px;

                .p-1 {
                  font-size: 12px;
                }

                .p-2 {
                  font-size: 22px;
                }
              }
            }
          }

          .card-box3 {
            display: flex;
            align-items: center;
            justify-content: space-around;

            .card-content-box {
              width: 49%;
              height: 200px;
              background-color: #f9fafd;

              .el-input__inner {
                font-size: 22px;
                font-weight: bold;
              }

              .content-title {
                background-color: #ecf2fc;
                line-height: 40px;
                padding-left: 10px;
                font-weight: bold;
                font-size: 14px;
              }

              .content-text {
                p {
                  font-size: 12px;
                  line-height: 50px;
                }

                .el-input__icon {
                  color: #1d5ac9;
                }
              }

              .content-text1 {
                padding-top: 10px;

                p {
                  font-size: 12px;
                  line-height: 30px;
                }
              }
            }
          }

          .card-box4 {
            padding: 0 10px 10px;

            .card-box4-title {
              line-height: 40px;
              border-bottom: 1px solid #e3e3e3;

              span:first-child {
                font-size: 14px;
                font-weight: bold;
                margin-right: 10px;
              }

              span {
                font-size: 12px;
              }

              i {
                font-size: 12px;
              }
            }

            .card-box4-content {
              span {
                font-size: 12px;
                line-height: 40px;
              }
            }
          }
        }
      }
    }

    .footer-box {
      position: absolute;
      bottom: 0;
      left: 0;
      z-index: 10;
      width: 100%;
      background-color: #fff;
      box-shadow: 0 -2px 5px 0 rgba(6, 13, 97, 0.102);

      .footer-box-content {
        width: 1136px;
        height: 32px;
        line-height: 32px;
        padding: 8px 0;
        margin: 0 auto;
        text-align: center;
      }
    }
  }

  .page-content-second {
    width: inherit;
    height: calc(100vh - 100px);
    overflow-y: auto;
    background-color: #f7f8fa;

    .layout-content-main {
      width: 1184px;
      margin: 0 auto;
      border-radius: 2px;

      :deep(.box-card) {
        width: inherit;
        box-shadow: none;

        .el-card__header {
          .header-box {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
          }
        }

        .el-card__body {
          height: 618px;
          padding: 0 20px;

          > .card-box3 {
            position: relative;
            height: inherit;

            .title-text {
              line-height: 40px;
              font-weight: 700;
            }

            .shuie-item-box {
              width: 100%;
              padding-top: 15px;
              display: flex;
              flex-wrap: nowrap;
              justify-content: space-between;
              align-items: center;

              .content-text-box {
                width: 25%;
                padding: 0 10px;
                border-right: 4px solid #fff;

                &:last-child {
                  border-right: none;
                }
              }
            }

            .btns-box {
              position: absolute;
              bottom: 0;
              left: 0;
              width: 100%;
              margin-bottom: 10px;
              display: flex;
              align-items: center;
              justify-content: space-between;

              .left-btn-box {
                display: inline-block;
                margin-right: 12px;
                font-size: 12px;
              }
            }
          }
        }
      }
    }
  }

  .page-content-four {
    width: inherit;
    height: calc(100vh - 100px);
    overflow-y: auto;
    background-color: #f7f8fa;

    .four-content {
      width: 1184px;
      margin: 0 auto;
      border-radius: 2px;
      background-color: #FFFFFF;
      padding: 0 24px;
      box-sizing: border-box;

      .title-m {
        padding: 25px 0 20px;
        margin-bottom: 24px;
        font-size: 20px;
        font-weight: 550;
        color: #333;
        border-bottom: 1px solid rgba(0, 0, 0, .1);
      }

      .sub-form-label {
        padding-bottom: 10px;
      }

      .mode-choose {
        display: flex;

        .mode-item {
          flex-grow: 1;
          background: #f9fafd;
          border: 1px solid #f9fafd;
          transition: all ease 0.3s;
          height: 106px;
          padding: 24px 21px 24px 24px;
          box-sizing: border-box;
          border-radius: 3px;
          cursor: pointer;
          position: relative;

          > h3 {
            font-size: 16px;
            font-weight: 600;
            line-height: 24px;
            color: #333;
          }

          > h4 {
            margin-top: 12px;
            font-size: 16px;
            line-height: 22px;
            color: #666;
          }

          .act-icon {
            position: absolute;
            right: 10px;
            top: 10px;
            display: none;
          }

          & + .mode-item {
            margin-left: 16px;
          }

          &.active {
            border: 1px solid #4285f4;

            .act-icon {
              display: block;
            }
          }
        }
      }

      .opera-t {
        margin-top: 32px;
        display: flex;
        justify-content: center;
        padding: 5px 0;
      }
    }
  }
}
</style>
